var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[(_vm.$slots.header)?_c('h5',{staticClass:"card-title"},[_vm._t("header")],2):_vm._e(),_vm._t("default")],2),(_vm.$slots.action)?_c('div',{staticClass:"card-footer"},[_vm._t("action")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }